import { render, staticRenderFns } from "./questionnaireGetCoupon.vue?vue&type=template&id=0a73c270&scoped=true&"
import script from "./questionnaireGetCoupon.vue?vue&type=script&lang=ts&"
export * from "./questionnaireGetCoupon.vue?vue&type=script&lang=ts&"
import style0 from "./questionnaireGetCoupon.vue?vue&type=style&index=0&id=0a73c270&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a73c270",
  null
  
)

export default component.exports